<header mat-dialog-title>{{ file.name }}</header>
<button test-id="dialog-close-button" mat-icon-button [mat-dialog-close]="modified" class="mat-dialog-close-button">
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content>
  <ng-container *ngIf="!error; else errorMessage">
    <div class="header-row">
      <div class="file-version">{{ getTranslation('headers.version') }}</div>
      <div class="file-origin">{{ getTranslation('headers.origin') }}</div>
      <div class="file-timestamp">{{ getTranslation('headers.timestamp') }}</div>
      <div class="file-actions">{{ getTranslation('headers.actions') }}</div>
    </div>
    <div *ngFor="let version of versions$ | async; first as $first" class="data-row">
      <div class="file-version">
        {{ version.version }}
        <ng-container *ngIf="version.restored_from as from">{{ getTranslation('columns.restoredFrom') | interpolate:from }}</ng-container>
      </div>
      <div class="file-origin" [ngSwitch]="getOrigin(version).type">
        <ng-container>
          <span>{{ getTranslation('columns.originActionBy') | interpolate:(getOriginAction(version) | titlecase) }}</span>
          <span>&nbsp;</span>
        </ng-container>
        <span *ngSwitchCase="'user'">{{ getTranslation('columns.originUser') | interpolate:getOrigin(version).id }}</span>
        <span *ngSwitchCase="'device'">{{ getTranslation('columns.originDevice') | interpolate:getOrigin(version).id }}</span>
        <span *ngSwitchCase="'job'">{{ getTranslation('columns.originJob') | interpolate:getOrigin(version).id }}</span>
        <span *ngSwitchCase="'system'">{{ getTranslation('columns.originSystem') }}</span>
        <span *ngSwitchDefault>{{ getTranslation('columns.originUnknown') }}</span>
        <ng-container *ngIf="getOriginAction(version) === 'copied' && copySourceLabels as sourceLabels">
          <span>&nbsp;</span>
          <span
            [innerHTML]="getTranslation('columns.copiedFrom') | interpolate:sourceLabels.project:sourceLabels.group | trusthtml">
          </span>
        </ng-container>
      </div>
      <div class="file-timestamp">{{ version.created | date:'yyyy-MM-dd HH:mm:ss' }}</div>
      <div class="file-actions">
        <ng-container *ngIf="!$first; else activeActions">
          <ng-container *ngIf="!version.deleted; else deletedActions">
            <fw-tooltip title="Delete" position="below">
              <fw-icon-button *ngIf="canDelete(version)" (click)="delete(version)" icon="trash-delete"></fw-icon-button>
            </fw-tooltip>
            <fw-tooltip title="Restore" position="below">
              <fw-icon-button *ngIf="permissions.createUpload" (click)="restore(version)" icon="clock-history"></fw-icon-button>
            </fw-tooltip>
            <fw-tooltip title="Information" position="below">
              <fw-icon-button (click)="information(version)" icon="information-circle"></fw-icon-button>
            </fw-tooltip>
          </ng-container>
        </ng-container>
      </div>
      <ng-template #activeActions>
        <fw-tooltip title="Information" position="below">
          <fw-icon-button (click)="information(version)" icon="information-circle"></fw-icon-button>
        </fw-tooltip>
      </ng-template>
      <ng-template #deletedActions>
        <span class="deleted-actions">Deleted file version</span>
      </ng-template>
    </div>
    <ng-container *ngIf="(versions$ | async)?.length === 0">
      {{ getTranslation('empty') }}
    </ng-container>
  </ng-container>
  <ng-template #errorMessage>
    <div class="error-message">{{ getTranslation('error') }}</div>
  </ng-template>
</div>
